import React, { useState, useContext, useEffect } from "react";
import Button from "./Button";
import Header from "./Header";
import { AppContext } from "../context";
import {
  setLog,
  userLogs,
  patLogs,
  makeRequest,
  translateText,
} from "../context/utils";
import Navbar from "./Navbar";
import SafeImage from "./SafeImage";

const Restart = () => {
  const { setScreen, token, inspectionId, config, showAlert, clientId } =
    useContext(AppContext);

  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const [screenHeight, setScreenHeight] = useState(land() ? false : true);

  window.onresize = () => {
    setScreenHeight(land() ? false : true);
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const onContinue = () => {
    patLogs(
      "Continue button is clicked on restart page",
      inspectionId,
      "restart"
    );
    setScreen("instructions");
  };

  const onRestart = async () => {
    try {
      patLogs("Restart button is clicked", inspectionId, "restart");
      const res = await makeRequest(`/restartInspection/${token}`);
      if (res.ok) {
        location.reload();
      } else {
        //show an alert of refreshing the page again as somethibng went wrong
      }
    } catch (err) {
      // console.log(err);
    }
  };

  useEffect(() => {
    patLogs("Skip Email page and Entered to restart page", inspectionId);
    userLogs({ position: 8, last_page: "restart page", inspectionId });
    if (["porto_seguros"].includes(clientId)) onContinue();
  }, []);

  return (
    <div
      className="screen_email"
      style={{
        height: screenHeight ? "100dvh" : "",
        position: screenHeight ? "relative" : "",
        padding: screenHeight ? "0%" : "",
      }}
    >
      <Navbar />
      <div
        id="screen1"
        className="email_screen"
        style={{
          height: screenHeight ? "70vh" : "",
          justifyContent: screenHeight ? "space-evenly" : "",
        }}
      >
        <Header />
        {/* <Header /> */}
        <SafeImage src={config["intro-page"]["image"]} style={clientId === "client_876" ? { width: "70%" } : {}} />
        {clientId === "client_876" && <SafeImage style={{ width: "50%" }} src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/inspektlabs.svg" fallback={null} />}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          <h2 className="header2" style={{ fontSize: "larger" }}>
            {config["errors"]["restart-page-text"]
              ? config["errors"]["restart-page-text"]
              : getTranslateText(
                "Do you want to continue old inspection or start a new inspection?"
              )}
          </h2>
          <div
            id="restart-btn-div"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
          >
            <Button
              wide={true}
              onclick={onContinue}
              text={
                config["errors"]["continue-btn"]
                  ? config["errors"]["continue-btn"]
                  : getTranslateText("Continue Old Inspection")
              }
            />
            <Button
              secoundaryBtn="true"
              wide={true}
              onclick={onRestart}
              text={
                config["errors"]["restart-btn"]
                  ? config["errors"]["restart-btn"]
                  : getTranslateText("Start New Inspection")
              }
            />
          </div>
        </div>
        <div className="InternetWarning">
          <p>{showAlert && showAlert}</p>
        </div>
      </div>
    </div>
  );
};

export default Restart;
